import React, { useCallback, useRef } from 'react';
import styles from './KioskLogoutGesture.module.css';

interface KioskLogoutGestureProps {
  /** 로그아웃 확정 시 호출 (localStorage 정리 + KioskLogin 복귀) */
  onLogout: () => void;
}

const REQUIRED_TAPS = 5;
const TAP_WINDOW_MS = 2000;

/**
 * 화면 좌상단 숨김 영역을 짧은 시간 안에 5회 연속 탭하면
 * 확인 후 로그아웃하는 제스처 (고객 오조작 방지용 — 시각적으로 드러나지 않음)
 */
export function KioskLogoutGesture({ onLogout }: KioskLogoutGestureProps) {
  const tapCount = useRef(0);
  const firstTapAt = useRef(0);

  const handleTap = useCallback(() => {
    const now = Date.now();
    if (now - firstTapAt.current > TAP_WINDOW_MS) {
      tapCount.current = 0;
      firstTapAt.current = now;
    }
    tapCount.current += 1;

    if (tapCount.current >= REQUIRED_TAPS) {
      tapCount.current = 0;
      firstTapAt.current = 0;
      const ok = window.confirm(
        '키오스크에서 로그아웃하시겠습니까?\n로그아웃 후에는 다시 매장 로그인이 필요합니다.',
      );
      if (ok) {
        onLogout();
      }
    }
  }, [onLogout]);

  return (
    <div
      className={styles.hotspot}
      onClick={handleTap}
      aria-hidden="true"
    />
  );
}
